// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FF-CommonAsterisk {
  position: absolute;
  top: -1px;
  left: -0.5rem;
  font: var(--typography-heading-3);
}

.FF-CommonAsterisk--isWarning {
  color: var(--color-foreground-warning-medium);
}

.FF-CommonAsterisk--isCritical {
  color: var(--color-foreground-critical-medium);
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/CommonAsterisk/CommonAsterisk.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;AAChD","sourcesContent":[".FF-CommonAsterisk {\n  position: absolute;\n  top: -1px;\n  left: -0.5rem;\n  font: var(--typography-heading-3);\n}\n\n.FF-CommonAsterisk--isWarning {\n  color: var(--color-foreground-warning-medium);\n}\n\n.FF-CommonAsterisk--isCritical {\n  color: var(--color-foreground-critical-medium);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
